import React from 'react'
import "./About.css"
import AboutMeImage from '../../assets/paul2.jpg'
import { FaAward, FaFolder } from 'react-icons/fa'


const About = () => {
    return (
        <section id="about">

            <h5>Get to know me.</h5>
            <h2><b>About Me!</b></h2>
            <div className="container about__container">
                <div className="about__me">
                    <div className="about__me-image">
                        <img src={AboutMeImage} alt="About Me Image" />
                    </div>

                </div>
                <div className="about__content">
                    <div className="about__cards">
                        <article className='about__card'>
                            <FaAward className='about__icon' />
                            <h4>Experience</h4>
                            <h5><b>IT Technical Support</b></h5>
                            <small>Inari Amertron Inc.</small><br />
                            <small>July 2023 - Prsent</small>
                        </article>



                        <article className='about__card'>
                            <FaFolder className='about__icon' />
                            <h5>Bachelor's Degree</h5>
                            <h5><b> Information Technology</b></h5>
                            <small>2018 - 2022</small>
                        </article>

                    </div>
                    <p>
                        I, <b>JOHN PAUL DE JESUS SALAZAR</b>, a graduate of <b>Bachelor of Science in Information Technology</b> at Mabalacat City College - Mabalacat City, Pampanga.
                    </p>

                    <p>
                        Currently serving as an  <b>IT Technical Support Specialist</b> at <b>Inari Amertron Incorporated</b>, providing technical assistance and ensuring smooth IT operations in a semiconductor manufacturing environment.
                    </p>

                    <p>
                        My work involves troubleshooting and installing hardware and software, monitoring and managing servers, and handling basic network administration to support daily operations.
                    </p>
                    <a href="#contact" className='btn btn-primary'>Let's talk!</a>
                </div>
            </div>
        </section>
    )
}

export default About